<template>
  <BaseModal
    @close="close"
    class="modal-nutsbp-login"
  >
    <div class="modal-nutsbp-login-container">
      <ModalTip class="modal-nutsbp-login-tip">{{lang.tip}}</ModalTip>
      <div @click="close" class="icon icon-dc_phone_icon_all_close"></div>
      <div class="modal-nutsbp-login-body">
        <div class="modal-logo"></div>
        <SigninForm
          :error="error"
          @commit="commit"
          @reset="reset"
          @signup="signup"
          @update:error="v => error = v"
        ></SigninForm>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import env from '@/env.js'

import BaseModal from './BaseModal.vue'
import { BaseInput } from '../input'
import { ModalTip } from '../tip'
import { SigninForm } from '../form'
export default {
  components: {
    BaseModal,
    BaseInput,
    ModalTip,
    SigninForm
  },
  props: {
    lang: {
      type: Object,
      default () {
        return {
          tip: '请您登录疯狂BP账户，投递BP'
        }
      }
    },
    error: {
      type: String,
      default () {
        return null
      }
    }
  },
  methods: {
    close () { this.$emit('close') },
    commit (input) { this.$emit('commit', input) },
    reset () { window.open(env.editorUrlForget, '_blank') },
    signup () { window.open(env.editorUrlSignup, '_blank') }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.modal-nutsbp-login {
  & .modal-nutsbp-login-tip {
    position: absolute;
    text-align: left;
    top: -46px;
    width: 400px;
  }
  & .modal-nutsbp-login-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;

    background-color: var(--colorWhite);

    @media (--mediaPc) {
      height: 360px;
      width: 400px;
      border-radius: var(--borderRadius1);
    }
    @media (--mediaMobile) {
      height: 100%;
      width: 100%;
    }

    & .icon {
      position: absolute;
      cursor: pointer;
      right: 12px;
      top: 12px;
      color: var(--color6);
    }
    & .modal-nutsbp-login-body {
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    & .modal-close {
      position: absolute;
      padding: 12px;
      right: 0;
    }
    & .modal-logo {
      background-image: url('http://az.cdn.nutsbp.com/007/image/nuts_bp_logo/nuts_bp_logo_144x144.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;

      width: 100%;
      @media (--mediaPc) {
        margin-bottom: 10px;
        height: 66px;
      }
      @media (--mediaMobile) {
        position: absolute;
        top: -65%;
        height: calc(240px / var(--scaleMobile));
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/NutsbpLoginModal.vue